export const servicesData = [
    {
        link: '/services/cloud-operations/managed-it',
        title: 'Go to Managed IT page',
        name: 'Managed IT',
        key: 'CLOUD_OPERATIONS_MANAGED_IT',
    },
    {
        link: '/services/cloud-operations/cloud-hosting',
        title: 'Go to Cloud Hosting page',
        name: 'Cloud Hosting',
        key: 'CLOUD_OPERATIONS_CLOUD_HOSTING',
    },
    {
        link: '/services/cloud-operations/security-and-compliance-advisory',
        title: 'Security and Compliance advisory',
        name: 'Security and Compliance advisory',
        key: 'CLOUD_OPERATIONS_SECURITY_AND_COMPLIANCE_ADVISORY',
    },
];
